import api from "./api";
import UserService from "./user.service";
import { isAdmin } from "src/Common/function";

const create = (data, branch) => {
  return api.post("/api/invite/create", data);
};

const accept = (data) => {
  const { token, name, password, phone } = data;
  return api.post("/api/invite/accept", { name, password, phone }, { params: { token } });
};

// The invite behind an emailed token, so the accept page can pre-fill the name.
// Public (the invitee isn't signed in yet); the token is the credential.
const getByToken = (token) => {
  return api.get("/api/invite/by-token", { params: { token } });
};

const getAll = (branch) => {
  // let currentUser = UserService.getCurrentUser();
  let branchId = branch;
  // if (!isAdmin()) {
  //   branchId = currentUser.branches[0].id;
  // }
  return api.get("/api/invite/get-all", { params: { branchId } });
};

const getPendingAll = () => {
  return api.get("/api/invite/get-pending-all");
};

const deleteInvite = (id) => {
  return api.delete("/api/invite/delete", { params: { id } });
};

const resend = (id) => {
  return api.post("/api/invite/resend", { id });
};

const InviteService = {
  create,
  accept,
  getByToken,
  getAll,
  getPendingAll,
  deleteInvite,
  resend,
};

export default InviteService;
